import React, { Component } from 'react';
import { Reports } from '$components/account';
import { fetchAll } from '$actions/reports';
import { changeTitle } from '$actions/root';
import { connect } from 'react-redux';
import { reportsSelector } from '$selectors';
import take from 'lodash/take';
import { clear } from '$actions/root';
import {Translate} from "$common";

@connect(state => ({
  reports: reportsSelector(state),
  hasMore: state.reports.hasMore,
  isFetching: state.reports.isFetching
}), { fetchAll, clear, changeTitle })
export default class ReportsRoute extends Component {
  state = {
    page: 1
  }

  fetch() {
    const params = { page: this.state.page };
    this.props.fetchAll(params);
    this.stopLoadMore = false;
  }

  loadMore() {
    if (this.stopLoadMore) return;
    this.stopLoadMore = true;
    this.setState({ page: this.state.page + 1 }, ::this.fetch);
  }

  componentWillMount() {
    this.props.changeTitle(Translate.get('reports'))
    this.props.clear('REPORTS');
    this.fetch();
  }

  render() {
    const { reports, hasMore, isFetching } = this.props;
    const { page } = this.state;

    return (
      <Reports
        reports={isFetching && page === 1 ? [] : take(reports, this.state.page * 25)}
        loadMore={::this.loadMore}
        hasMore={hasMore}
        isFetching={isFetching}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/account/reports.js